module.exports = __webpack_public_path__ + "img/coming-soon.2500498f.svg";